import { gql } from "@apollo/client";

export const GET_INDUSTRIES_PAGINATED = gql`
  query GetIndustryPaginated(
    $getIndustryPaginated: GetIndustryPaginatedInput!
  ) {
    getIndustryPaginated(getIndustryPaginated: $getIndustryPaginated) {
      total
      industriesPaginated {
        id
        name
        description
      }
    }
  }
`;

export const GET_INDUSTRY_BY_ID = gql`
  query GetIndustryById($getIndustryByIdId: String!) {
    getIndustryById(id: $getIndustryByIdId) {
      id
      name
      description
    }
  }
`;

export const GET_ALL_INDUSTRIES = gql`
  query GetAllIndustries {
    getAllIndustries {
      id
      name
      description
    }
  }
`;

export default {
  GET_INDUSTRIES_PAGINATED,
  GET_INDUSTRY_BY_ID,
  GET_ALL_INDUSTRIES,
};
